export const createCalendar = {
    "id": 11111,
    "calendarId": 11111,
    "name": "Mocked calendar",
    "calendarGroupId": 0,
    "isPublished": true,
    "type": "Custom",
    "isVisible": true,
    "timestamp": 123456789
}